import React, { Fragment } from "react";
import vidaLitoral from "../Images/vida_litoral.jpg";
import vidaLitoralDigital from "../Images/vida_litoral_digital.png";
import { ParallaxBanner } from "react-scroll-parallax";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faLaptop, faMobilePhone } from "@fortawesome/free-solid-svg-icons";

const VidaLitoral = () => {
  return (
    <Fragment>
      <div className="container-body position-relative">
        <ParallaxBanner
          layers={[{ image: vidaLitoral, speed: 50 }]}
          className="bg-container aspect-2-1"
        ></ParallaxBanner>
        <div className="position-absolute top-0 h-100 w-100 filter-dark d-flex">
          <div className="container my-auto text-end text-light">
            <h4>Publicacion Nro. 51</h4>
            <h2>Vida Litoral Magazine</h2>
            <h4>
              <a href="https://vidalitoral.com/">vidalitoral.com</a>
            </h4>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-6 d-flex align-items-center">
            <img src={vidaLitoralDigital} alt="Revista vida litoral" className="img-fluid d-block" />
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <div className="bg-white p-5 shadow rounded-3">
              <p>
                Una revista que marca tendencia.Plataforma impresa y digital dedicada a difundir el arte, la
                gastronomía, la arquitectura, los atractivos turísticos, las tradiciones, la moda y todo el
                acontecer y la actualidad del LITORAL y ESTE del URUGUAY.
              </p>
              <p>
                MIX EDITORIAL con contenidos propios y novedosos del litoral uruguayo argentino (departamentos
                de Artigas, Salto, Paysandú, Río Negro, Soriano, Colonia y Entre Rios Argentina ) con Destino
                Especial Punta del Este y su zona de influencia.
              </p>
              <p>
                Para saber todo lo que pasa de un lado y el otro del Río Uruguay, planificar las vacaciones,
                agendar eventos, estar a punto de lo nuevo en arte, música, libros , cine, cultura, paseos ,
                eventos, lanzamientos, lugares. Para entusiasmarse con las compras, elegir dónde comer y
                divertirse… Para estar al tanto de toda la movida la región rioplatense…
              </p>
              <hr />
              <p className="fw-bold">
                Cubrimos eventos y actualidad. Si tenes algo para comunicar, podemos ofrecerte nuestros
                servicios. Tenemos un equipo que puede asesorarte.
              </p>
              <div className="text-center border rounded-3">
                <h5>Contacto</h5>
                <p className="mb-1">
                  <FontAwesomeIcon icon={faAt} />
                  <a href="mailto:vidalitoralmagazine@gmail.com" className="text-decoration-none">
                    {" "}
                    vidalitoralmagazine@gmail.com
                  </a>
                </p>
                <p className="mb-1">
                  <FontAwesomeIcon icon={faMobilePhone} />
                  <a href="tel:+59899728233" className="text-decoration-none">
                    {" "}
                    (+598) 99 728 233
                  </a>
                </p>
                <p className="mb-1">
                  <FontAwesomeIcon icon={faLaptop} />
                  <a href="https://vidalitoral.com/" className="text-decoration-none">
                    {" "}
                    https://vidalitoral.com/
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VidaLitoral;
